var _style, _g, _g2, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _g3, _path4, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F7F7F7;}\n\t.st1{fill:none;stroke:#D3D3D3;stroke-miterlimit:10;stroke-dasharray:12.1401,12.1401;}\n\t.st2{fill:#F2F2F2;}\n\t.st3{fill:#DCF2FF;}\n\t.st4{fill:#2A94F4;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#FFBE55;}\n\t.st7{fill:#072C3D;}\n\t.st8{fill:#FCD2B1;}\n\t.st9{fill:#0E538C;}\n\t.st10{fill:#FFE3CA;}\n\t.st11{fill:none;stroke:#0E538C;stroke-width:2;stroke-miterlimit:10;}\n\t.st12{fill:#1A87D8;}\n\t.st13{fill:#B0E1FF;}\n\t.st14{fill:#CCE9FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.1,177.7c-23.9,10.4-47.6,23.2-64.3,43.2s-25.1,48.7-15,72.8c13.4,32.1,55.8,50.8,56,85.6   c0.1,24.9-22.9,43.9-46.1,53c-23.2,9.1-48.9,12.3-70,25.6c-31.9,20-46.8,58.7-52.9,95.8c-6.3,38.5-3.8,82.4,23.5,110.4   c33.9,34.7,89.9,30.8,137.9,23.4c64-9.9,127.7-21.5,191.5-33.1c139.7-25.5,279.4-50.9,419-76.4c15-2.7,30.6-5.7,42.7-14.9   c24.2-18.2,26.2-55.7,12.2-82.4c-14-26.8-40-45-65.8-60.7s-53.1-30.6-72.4-53.9s-28.9-57.7-14.3-84.1c12.4-22.4,39-34.4,50.6-57.2   c15.3-30.1-2.3-68.5-30.1-87.7C770.7,117.7,422.2,122.5,296.1,177.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 224.7,
    cy: 203.5,
    r: 123.7
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1022.5,861h-965c-7.2,0-13-5.9-13-13v-77.5c0-7.2,5.9-13,13-13h965c7.2,0,13,5.9,13,13V848  C1035.5,855.1,1029.6,861,1022.5,861z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M900,215v351c0,6.6-5.4,12-12,12H192c-6.6,0-12-5.4-12-12V215c0-6.6,5.4-12,12-12h696  C894.6,203,900,208.4,900,215z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M900,215v25H180v-25c0-6.6,5.4-12,12-12h696C894.6,203,900,208.4,900,215z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 264,
    className: "st5",
    width: 252,
    height: 19
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 514,
    y: 332,
    className: "st5",
    width: 252,
    height: 19
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 366,
    className: "st5",
    width: 454,
    height: 19
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 298,
    className: "st5",
    width: 413,
    height: 19
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 468,
    y: 264,
    className: "st6",
    width: 105,
    height: 19
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 434,
    className: "st5",
    width: 252,
    height: 19
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 468,
    y: 434,
    className: "st6",
    width: 105,
    height: 19
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 625,
    y: 298,
    className: "st6",
    width: 152,
    height: 19
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 400,
    className: "st6",
    width: 182,
    height: 19
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 332,
    className: "st6",
    width: 298,
    height: 19
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 467.7,
    y: 756.4,
    className: "st7",
    width: 152.6,
    height: 35
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M430.8,797.9c26,6.5,121.9,17.2,169.6,22.2c10.6,1.1,18.8,2,23.4,2.4c2.5,0.3,3.9,0.4,3.9,0.4     s12.5-0.8,27.7-1.6c14-0.8,46.3-0.6,57.5-1c4.2-0.1,5.6-5.8,2-7.9c-6.6-3.8-34.3-15.1-47.9-16.8c-8.4-1-17.6-8.6-24.9-12.8     c-5.6-3.3-12,2.4-17.1,4.3c-2.5,0.9-4.3,6.5-7.1,6.7c-0.7,0.1-1.4,0.1-2.1,0.2c-3.5,0.2-7.2,0-10.7-0.4c-1-0.1-1.9-0.3-2.9-0.4     c-11.1-1.7-20.3-5.3-20.3-5.3c-34-17.6-108.8-64.7-167-52.3c-0.5,0.1-1,0.2-1.4,0.3c-0.5,0.1-1,0.2-1.4,0.3     C353.5,751.1,395.8,789.1,430.8,797.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M430.8,797.9c26,6.5,121.9,17.2,169.6,22.2l8.7-50.3c-1.7-0.3-3.5-0.4-5.3-0.4c-18.4-0.2-36.6-4-53.6-11.2     c-38.6-16.5-93.2-33.1-138.2-21.9C353.5,751.1,395.8,789.1,430.8,797.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M639.1,784c0-5,6-8,6-8l46.6,17.2l25.4,13.8l5,7l-6,4.5l-52-7.5l-17-10L639.1,784z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M615.7,794l8.1,28.5c2.5,0.3,3.9,0.4,3.9,0.4s12.5-0.8,27.7-1.6c14-0.8,46.3-0.6,57.5-1    c4.2-0.1,5.6-5.8,2-7.9c-6.6-3.8-34.3-15.1-47.9-16.8c-8.4-1-17.6-8.6-24.9-12.8c-5.6-3.3-12,2.4-17.1,4.3    c-2.5,0.9-4.3,6.5-7.1,6.7C617.1,794,616.4,794,615.7,794z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M650.3,625.3l-6.3-46.6c-3.2-23.4-21.7-40.8-43.6-40.8h-42.4c-6.1,0-16.1,0-22.2,0h-42.4   c-21.9,0-40.4,17.4-43.6,40.8l-6.3,46.6c-4.9,36.6,15.6,71.6,48.4,82.3l43.8,14.3c6.1,0,11.1-5.4,11.1-12c0,6.6,5,12,11.1,12   l43.8-14.3C634.6,696.9,655.2,661.9,650.3,625.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3569 -0.9341 0.9341 0.3569 -84.9471 864.6035)",
    className: "st10",
    cx: 585.5,
    cy: 494,
    rx: 9,
    ry: 7.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "631.4,750.7 464.7,745.1 454.2,600.4 644.1,600.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M528.4,523.3l5.5,33.4l0.4,0.8c5,10.6,20.2,10.1,24.5-0.8v0l4.5-33.9L528.4,523.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M585.3,480.5c0,42.5-17,50.9-37.9,50.9c-20.9,0-37.9-8.3-37.9-50.9c0-23.1,17-41.8,37.9-41.8   C568.3,438.6,585.3,457.4,585.3,480.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M524.8,469.9c17,9.3,35.5,15.9,54.6,19.5c7.5,1.4,24.9-7.5,29.6-13.4c5.1-6.3-14-6-18-13    c-5.7-9.9-11.4-22.9-21-29s-23.8-0.2-35,2c-10,2-13-1.4-21,5c-6.6,5.3-10.7,15.7-13,23.8c-2.3,8.1,0.7,25.3,9,27.2    c2-12,6.8-15.1,9-21L524.8,469.9z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9341 -0.3569 0.3569 0.9341 -142.7003 214.7587)",
    className: "st10",
    cx: 510.5,
    cy: 494,
    rx: 7.5,
    ry: 9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M537.9,507h-19c-3.1,0-5.6-2.5-5.6-5.6v-5.7c0-3.1,2.5-5.6,5.6-5.6h19c3.1,0,5.6,2.5,5.6,5.6v5.7    C543.5,504.5,541,507,537.9,507z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M575.9,507h-19c-3.1,0-5.6-2.5-5.6-5.6v-5.7c0-3.1,2.5-5.6,5.6-5.6h19c3.1,0,5.6,2.5,5.6,5.6v5.7    C581.5,504.5,579,507,575.9,507z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M543.5,498.5c2.8-1.5,4.8-2.5,7.8,0"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M626.4,768.8H465.7c-4.9,0-9-4-9-9l-4.5-108.7c0-4.9,4-9,9-9h169.7c4.9,0,9,4,9,9l-4.5,108.7   C635.3,764.8,631.3,768.8,626.4,768.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 545.7,
    cy: 705.5,
    r: 17
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M674.3,797.9c-26,6.5-121.9,17.2-169.6,22.2c-10.6,1.1-18.8,2-23.4,2.4c-2.5,0.3-3.9,0.4-3.9,0.4     s-12.5-0.8-27.7-1.6c-14-0.8-46.3-0.6-57.5-1c-4.2-0.1-5.6-5.8-2-7.9c6.6-3.8,34.3-15.1,47.9-16.8c8.4-1,17.6-8.6,24.9-12.8     c5.6-3.3,12,2.4,17.1,4.3c2.5,0.9,4.3,6.5,7.1,6.7c0.7,0.1,1.4,0.1,2.1,0.2c3.5,0.2,7.2,0,10.7-0.4c1-0.1,1.9-0.3,2.9-0.4     c11.1-1.7,20.3-5.3,20.3-5.3c34-17.6,108.8-64.7,167-52.3c0.5,0.1,1,0.2,1.4,0.3c0.5,0.1,1,0.2,1.4,0.3     C751.6,751.1,709.3,789.1,674.3,797.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M674.3,797.9c-26,6.5-121.9,17.2-169.6,22.2l-8.7-50.3c1.7-0.3,3.5-0.4,5.3-0.4c18.4-0.2,36.6-4,53.6-11.2     c38.6-16.5,93.2-33.1,138.2-21.9C751.6,751.1,709.3,789.1,674.3,797.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M466,784c0-5-6-8-6-8l-46.6,17.2L388,807l-5,7l6,4.5l52-7.5l17-10L466,784z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M489.4,794l-8.1,28.5c-2.5,0.3-3.9,0.4-3.9,0.4s-12.5-0.8-27.7-1.6c-14-0.8-46.3-0.6-57.5-1    c-4.2-0.1-5.6-5.8-2-7.9c6.6-3.8,34.3-15.1,47.9-16.8c8.4-1,17.6-8.6,24.9-12.8c5.6-3.3,12,2.4,17.1,4.3c2.5,0.9,4.3,6.5,7.1,6.7    C488.1,794,488.8,794,489.4,794z"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M937,132H739c-23.6,0-43,21.4-43,47.5v0c0,23.9,16.1,43.8,36.9,47l0.6,20.9l20.7-20.4H937  c23.6,0,43-21.4,43-47.5v0C980,153.4,960.7,132,937,132z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 787,
    cy: 181,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 838,
    cy: 181,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 889,
    cy: 181,
    r: 15
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 220.5,
    cy: 577.5,
    r: 80.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M164.8,582.5v-4.4c0-2.2,1.3-4.1,3.3-4.9l22.2-8.8c3.5-1.4,7.2,1.2,7.2,4.9l0,0c0,2.3-1.4,4.3-3.6,5l-17.9,6    l17.9,6c2.2,0.7,3.6,2.7,3.6,5v0.1c0,3.7-3.8,6.3-7.2,4.9l-22.2-8.8C166.2,586.6,164.8,584.7,164.8,582.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M232.4,550.9L232.4,550.9c3.4,0,5.6,3.5,4.1,6.6l-24.8,51.9c-0.8,1.6-2.4,2.6-4.1,2.6h0    c-3.4,0-5.6-3.5-4.1-6.6l24.8-51.9C229.1,551.9,230.7,550.9,232.4,550.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M247,586.4l17.9-6l-17.9-6c-2.1-0.7-3.6-2.7-3.6-5v-0.1c0-3.7,3.8-6.3,7.2-4.9l22.2,8.8    c2,0.8,3.3,2.7,3.3,4.9v4.4c0,2.2-1.3,4.1-3.3,4.9l-22.2,8.8c-3.5,1.4-7.2-1.2-7.2-4.9l0,0C243.4,589.1,244.9,587.1,247,586.4z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M974.7,714.1c-8.2-38.5-33.7-72.9-68-92.1c18.4,34.7,40.3,67.4,65.5,97.6L974.7,714.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M983.9,728.5c-32.7-45.7-49.1-102.9-45.6-159c21.2,51.8,37.2,105.7,47.7,160.6L983.9,728.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M974.5,730.1c-1-28.1-2-56.5,2.4-84.3c4.4-27.8,14.6-55.3,33.5-76.2c2.9,57.6-11.1,115.9-39.6,166      L974.5,730.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M975.9,732.6c-18.4-53.2-15.4-113.4,8.2-164.5c14.8,53.4,1.7,110-11.4,163.8L975.9,732.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M978.3,712.9c5.1-46.7,36.2-89.6,79-108.9c-17.3,46.5-47,88.4-85.1,120.3L978.3,712.9z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1022.4,704.7l-5.3,90.6c0,4.4-3.6,7.9-7.9,7.9h-62.8c-4.4,0-7.9-3.6-7.9-7.9l-1.2-20.5l-4.1-70.1    c0-4.4,3.6-7.9,7.9-7.9h73.4c2.9,0,5.4,1.5,6.8,3.8v0C1021.9,701.8,1022.4,703.2,1022.4,704.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1022.4,704.7l-5.3,90.6c0,4.4-3.6,7.9-7.9,7.9h-62.8c-4.4,0-7.9-3.6-7.9-7.9l-1.2-20.5     c29.3-8.4,59.5-44.6,84-74.2C1021.9,701.8,1022.4,703.2,1022.4,704.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M91.2,744.9c-5.4-25.2-22-47.7-44.5-60.3c12,22.7,26.4,44.1,42.9,63.9L91.2,744.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97.2,754.3C75.8,724.4,65.1,687,67.4,650.3c13.9,33.9,24.4,69.2,31.2,105.2L97.2,754.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M91.1,755.4c-0.7-18.4-1.3-37,1.6-55.2s9.6-36.2,22-49.9c1.9,37.7-7.2,75.9-26,108.7L91.1,755.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M92,757c-12.1-34.8-10.1-74.3,5.4-107.7c9.7,34.9,1.1,72-7.5,107.2L92,757z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M93.6,744.1c3.3-30.5,23.7-58.7,51.7-71.3c-11.4,30.5-30.8,57.9-55.7,78.8L93.6,744.1z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M122.4,738.7l-3.5,59.3c0,2.9-2.3,5.2-5.2,5.2H72.6c-2.9,0-5.2-2.3-5.2-5.2l-0.8-13.4L64,738.7    c0-2.9,2.3-5.2,5.2-5.2h48.1c1.9,0,3.5,1,4.4,2.5v0C122.2,736.8,122.4,737.8,122.4,738.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M122.4,738.7l-3.5,59.3c0,2.9-2.3,5.2-5.2,5.2H72.6c-2.9,0-5.2-2.3-5.2-5.2l-0.8-13.4     c19.2-5.5,39-29.2,55-48.6C122.2,736.8,122.4,737.8,122.4,738.7z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoding);
export default __webpack_public_path__ + "static/media/coding.b74fee3941a05d19c2bbc1f8e36d88f0.svg";
export { ForwardRef as ReactComponent };